import React from 'react';
import { Tooltip } from 'antd';
import useTranslation from '../../hooks/translation/useTranslation';

function WagonStairs({ style = {} }) {
  const { trans } = useTranslation();
  return (
    <div className="wagon-feature" style={style}>
      <Tooltip title={trans('stairs')}>
        <img src="/wagon-icons/stairs.png" width={46} height={46} className="object-center" alt="stairs" />
      </Tooltip>
    </div>
  );
}

export default WagonStairs;
